import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncateText",
})
export class TruncateTextPipe implements PipeTransform {
  transform(
    value: string,
    args: { limit: number; completeWords: boolean } = {
      limit: 20,
      completeWords: false,
    }
  ): string {
    let text = "";
    if (value) {
      let limit = args.limit;
      const completeWords = args.completeWords;
      const ellipsis = "...";

      if (completeWords) {
        const index = value.substring(0, limit).lastIndexOf(" ");
        limit = index === -1 ? limit : index;
      }

      text = value.length > limit && !Date.parse(value) ? value.substring(0, limit) + ellipsis : value;
    }

    return text;
  }
}
